interface OAuthFlowResponse {
  flow: 'desktop' | 'web';
  provider: 'google' | 'discord';
}

/**
 * Desktop OAuth uses the same Google/Discord redirect URIs as web (`/auth/callback`).
 * When Google redirects to the SPA callback page, detect desktop flows and hand off
 * to the backend endpoint that posts credentials to the desktop app's localhost listener.
 */
export async function redirectDesktopOAuthIfNeeded(code: string, state: string): Promise<boolean> {
  const response = await fetch(`/api/v1/auth/oauth/flow/${encodeURIComponent(state)}`);
  if (!response.ok) {
    return false;
  }

  const data = (await response.json()) as OAuthFlowResponse;
  if (data.flow !== 'desktop') {
    return false;
  }

  const params = new URLSearchParams({ code, state });
  window.location.replace(`/api/v1/auth/desktop/callback?${params.toString()}`);
  return true;
}
